<template>
  <div>
    <jet-dialog-modal :show="openModal" @close="closeModal">
      <template #title><span class="font-bold">สคริปต์สำหรับติดตั้งแบนเนอร์คุกกี้</span></template>

      <template #content>
        <div class="mt-4">
          <p class="mb-1">
            คัดลอกสคริปต์นี้แล้วนำไปวางระหว่างแท็ก
            <span class="text-red-500">{{ '<head>' }}</span> และ <span class="text-red-500">{{ '</head>' }}</span>
            เหนือสคริปต์อื่น ๆ ของเว็บไซต์ของคุณ เพื่อให้ Cookie Pop ทำการบล็อกคุกกี้หรือสคริปต์อื่น ๆ ได้อย่างถูกต้อง
          </p>
          <p class="text-sm text-gray-500">หากคุณปรับแต่งแบนเนอร์แล้วคลิกอัปเดตสไตล์ แบนเนอร์ของคุณจะถูกอัปเดตอัตโนมัติโดยไม่ต้องคัดลอกสคริปต์อีกครั้ง</p>
          <div
            class="
              col-span-12
              px-6
              py-3
              my-2
              rounded
              border border-yr-primary-ii-300
              bg-yr-primary-50
            "
          >
            <p class="font-medium text-sm text-yr-primary-ii-500">
              {{ `<!-- Cookie Consent by ${baseUrl} -->` }} <br>
              {{ `<script type="text/javascript" src="${baseUrl}/dist/ckp.js"></script>` }} <br>
              {{ `<script id="cookiePop" type="text/javascript" src="${baseUrl}/configs/${projectCode}" data-cookiepopid="${projectCode}"></script>` }}
            </p>
          </div>
        </div>
        <div class="w-full flex justify-end items-center">
            <span class="text-xs text-green-500 mr-3">{{ copyTextAlert }}</span>
          <jet-button
          @click="copyScript"
            class="
              cursor-pointer
              inline-flex
              items-center
              px-4
              py-2
              bg-yr-primary-ii-500
              border border-transparent
              rounded-md
              font-semibold
              text-xs text-white
              uppercase
              tracking-widest
              hover:bg-yr-primary-ii-600
              active:bg-yr-primary-ii-700
              focus:outline-none
              focus:border-yr-primary-ii-700
              focus:ring
              focus:ring-yr-primary-ii-300
              transition
            "
          >
            คัดลอก
          </jet-button>
          <textarea class="hidden" ref="copyScript" v-html="copyScriptText"></textarea>
        </div>
        <p class="text-sm text-gray-500">หรือคัดลอดโค้ดสำหรับเชื่อมต่อกับผู้ให้บริการสร้างเว็บไซต์อื่น:</p>
        <div
          class="
            col-span-12
            px-6
            py-3
            my-2
            rounded
            border border-yr-primary-ii-300
            bg-yr-primary-50
          "
        >
          <p class="font-medium text-sm text-yr-primary-ii-500">{{ projectCode }}</p>
        </div>
      </template>

      <template #footer>
        <jet-secondary-button @click="closeModal"> ปิด </jet-secondary-button>
      </template>
    </jet-dialog-modal>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import JetDialogModal from "@/Jetstream/DialogModal.vue";
import JetButton from "@/Jetstream/Button.vue";
import JetSecondaryButton from "@/Jetstream/SecondaryButton.vue";

export default defineComponent({
  props: ["openModal", "projectCode", "baseUrl"],

  components: {
    JetDialogModal,
    JetSecondaryButton,
    JetButton,
  },

  data() {
    return {
      //   form: this.$inertia.form({
      //     domain_name: null,
      //   }),
      copyTextAlert: "",
      copyScriptText: "",
    };
  },

  mounted() {
    this.copyScriptText = `&lt;!-- Cookie Consent by ${this.baseUrl} --&gt;\n&lt;script type="text/javascript" src="${this.baseUrl}/dist/ckp.js"&gt;&lt;/script&gt;\n&lt;script id="cookiePop" type="text/javascript" src="${this.baseUrl}/configs/${this.projectCode}" data-cookiepopid="${this.projectCode}"&gt;&lt;/script&gt;`;
  },

  methods: {
    closeModal() {
      //   this.form.reset();
      this.$emit("close-modal");
    },

    copyScript() {
      let script = this.$refs.copyScript;
      navigator.clipboard.writeText(script.value).then(() => {
        /* clipboard successfully set */
        this.copyTextAlert = "คัดลอกแล้ว!";
      });
    },
  },

  watch: {
    openModal(value) {
      //   if (value) //open
      //     setTimeout(() => this.$refs.domain_name.focus(), 250);
    },
  },
});
</script>
